import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenPeriodSelectorComponent } from "./components/loren-period-selector/loren-period-selector.component";

@NgModule({
  declarations: [LorenPeriodSelectorComponent],
  exports: [LorenPeriodSelectorComponent],
  imports: [
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,

    ReactiveFormsModule,
    MatDatepickerModule,
    TranslocoModule,
  ],
})
export class LorenPeriodSelectorModule {}
